import React, { useState } from "react";
import axios from "axios";
import "../styles/contato.css";

const Contato = () => {
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    mensagem: ""
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const enviarFormulario = async (e) => {
    e.preventDefault();

    if (!formData.nome || !formData.email || !formData.mensagem) {
      setStatus("❌ Todos os campos são obrigatórios.");
      return;
    }

    try {
      const res = await axios.post("http://localhost:5000/api/contato", formData);
      if (res.status === 200) {
        setStatus("✅ Mensagem enviada com sucesso!");
        setFormData({ nome: "", email: "", mensagem: "" });
      }
    } catch (error) {
      console.error(error);
      setStatus("❌ Erro ao enviar. Tente novamente.");
    }
  };

  return (
    <div className="contato-container">
      <h2>Fale Conosco</h2>
      <form onSubmit={enviarFormulario}>
        <label>Nome:</label>
        <input
          type="text"
          name="nome"
          value={formData.nome}
          onChange={handleChange}
          required
        />

        <label>Email:</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <label>Mensagem:</label>
        <textarea
          name="mensagem"
          value={formData.mensagem}
          onChange={handleChange}
          rows="5"
          required
        />

        <button type="submit">Enviar</button>
      </form>
      {status && <p className="status">{status}</p>}
    </div>
  );
};

export default Contato;
